import {IUserProfile} from '@wholesalechange/chatcomponent';
import {errorHandler} from '../../redux/errorHandler';
import {ToastKey} from '../../components/gritx-toast/ToastKeyEnum';
import {useDispatch} from 'react-redux';
import {changeLocale} from '../../redux/translation/translationAsyncActions';
import {libClearSelectedFiltersAction} from '../../redux/content/actions';
import {clearCmSelectedFiltersAction} from '../../redux/cm-service/actions';
import {updateUserProfileAction} from '../../redux/auth/authAsyncActions';
import {getMainDialogueApi, setDialogueLanguageApi} from '../../redux/api/dialogue';

interface IUseChangeLanguage {
  changeLanguage: (userProfile: IUserProfile, language: string) => void
}

export const useChangeLanguage = (): IUseChangeLanguage => {
  const dispatch = useDispatch();

  async function setMainDialogLanguage(language: string) {
    let data;

    try {
      ({data} = await getMainDialogueApi());
    } catch (e) {
      // User has no main dialogue yet (e.g. never opened Chat) - nothing to update.
      console.log('useChangeLanguage getMainDialogueApi', e);
      return null;
    }

    if (data == null) {
      return null;
    }

    try {
      await setDialogueLanguageApi(data.id, language);
    } catch (e) {
      console.log('useChangeLanguage setMainDialogLanguage', e);
      dispatch(errorHandler({
        toastKey: ToastKey.SetDialogLanguage,
        actionKey: 'useChangeLanguage setMainDialogLanguage',
        error: e
      }));
    }

    return data;
  }

  async function changeLanguage(userProfile: IUserProfile, language: string) {
    setMainDialogLanguage(language);
    dispatch(changeLocale(language));
    dispatch(libClearSelectedFiltersAction());
    dispatch(clearCmSelectedFiltersAction());
    dispatch(updateUserProfileAction({
      ...userProfile,
      language: language
    } as IUserProfile));
  }

  return {
    changeLanguage
  };
};
